import {
    Component,
    computed,
    effect,
    inject,
    input,
    InputSignal,
    Signal,
    ChangeDetectionStrategy,
    signal,
    WritableSignal,
    untracked,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { emptyProjectQuery, ProjectQuery } from '@dat/datiq-nx-repo-utils';
import { IqStatusLibraryStateService } from '../state';
import { IqStatusLibraryCardComponent } from '../iq-status-library-card/iq-status-library-card.component';
import { ScrollingModule } from '@angular/cdk/scrolling';

@Component({
    selector: 'iq-status-library-card-grid',
    standalone: true,
    imports: [CommonModule, IqStatusLibraryCardComponent, ScrollingModule],
    templateUrl: './iq-status-library-card-grid.component.html',
    styleUrl: './iq-status-library-card-grid.component.scss',
})
export class IqStatusLibraryCardGridComponent {
    private _state: IqStatusLibraryStateService = inject(
        IqStatusLibraryStateService,
    );
    id: InputSignal<string> = input<string>();
    testId: InputSignal<string> = input<string>();
    query: InputSignal<ProjectQuery> = input<ProjectQuery>({
        ...emptyProjectQuery,
    });
    currentTestId: Signal<string> = computed(() => {
        return this.testId()?.length ? this.testId() : this.id();
    });

    projectKeys: string[] = [];
    allProjectKeys: string[] = [];

    pageSize: number = 9;

    maxCards: WritableSignal<number> = signal(this.pageSize);

    constructor() {
        effect(async () => {
            const query: ProjectQuery = this.query();

            this.allProjectKeys = await this._state.queryProjectKeys(query);

            untracked(() => {
                this.maxCards.set(this.pageSize);
                this.projectKeys = this.allProjectKeys.slice(
                    0,
                    this.maxCards(),
                );
            });
        });

        effect(() => {
            const maxCards = this.maxCards();

            this.projectKeys = this.allProjectKeys.slice(0, maxCards);
        });
    }

    loadMore(): void {
        this.maxCards.set(this.maxCards() + this.pageSize);
    }
}
